import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule, PromotionsModule } from '@spartacus/storefront';
import { PromotionalTextModule } from '../../promotional-text/promotional-text.module';
import { CartCouponModule } from '../cart-coupon/cart-coupon.module';
import { ItemCounterModule } from '../item-counter/item-counter.module';
import { MemoModule } from '../memo/memo.module';
import { CartItemListComponent } from './cart-item-list/cart-item-list.component';
import { CartItemComponent } from './cart-item/cart-item.component';
import { OrderSummaryComponent } from './order-summary/order-summary.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CartCouponModule,
    ReactiveFormsModule,
    UrlModule,
    NgbModule,
    PromotionsModule,
    I18nModule,
    MediaModule,
    MatTooltipModule,
    ItemCounterModule,
    FeaturesConfigModule,
    MatIconModule,
    PromotionalTextModule,
    MemoModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    CartItemComponent,
    OrderSummaryComponent,
    CartItemListComponent,
  ],
  exports: [CartItemComponent, CartItemListComponent, OrderSummaryComponent],
})
export class CartSharedModule {}
